<template>
  <button
    ref="dropdown"
    class="vs-con-dropdown parent-dropdown"
    type="button"
    v-bind="$attrs"
    @contextmenu="handleContextmenu"
    @click="handleClick"
    @mouseout="handleMouseout"
    @mouseover="handleMouseover"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "VsDropdown",
  inheritAttrs: false,
  props: {
    vsTriggerClick: {
      type: Boolean,
      default: false,
    },
    vsTriggerContextmenu: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    vsCustomContent: {
      type: Boolean,
      default: false,
    },
    vsDropRight: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click", "focus", "blur"],
  provide() {
    return {
      vsDropdown: this,
    };
  },
  data() {
    return {
      vsDropdownVisible: false,
      rightx: false,
      menu: null,
    };
  },
  watch: {
    vsDropdownVisible(visible) {
      if (visible) {
        this.$emit("focus");
        document.addEventListener("click", this.handleDocumentClick);
        this.$nextTick(this.updateMenuPosition);
      } else {
        this.$emit("blur");
        document.removeEventListener("click", this.handleDocumentClick);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    registerMenu(menu) {
      this.menu = menu;
    },
    unregisterMenu(menu) {
      if (this.menu === menu) this.menu = null;
    },
    setVisible(visible) {
      this.vsDropdownVisible = visible;
    },
    close() {
      this.setVisible(false);
    },
    handleClick(event) {
      if (!this.vsTriggerContextmenu) {
        if (this.vsTriggerClick) {
          this.setVisible(!this.vsDropdownVisible);
        }
        this.$emit("click", event);
      }
    },
    handleContextmenu(event) {
      if (!this.vsTriggerContextmenu) return;
      event.preventDefault();
      this.setVisible(!this.vsDropdownVisible);
      this.$emit("click", event);
    },
    handleMouseover() {
      if (!this.vsTriggerClick && !this.vsTriggerContextmenu) {
        this.setVisible(true);
      }
    },
    handleMouseout(event) {
      if (this.vsTriggerClick || this.vsTriggerContextmenu) return;
      const related = event.relatedTarget;
      if (
        related &&
        (this.$refs.dropdown.contains(related) ||
          related.closest(".vs-dropdown-menu"))
      ) {
        return;
      }
      this.setVisible(false);
    },
    handleDocumentClick(event) {
      const target = event.target;
      if (
        this.$refs.dropdown.contains(target) ||
        (target.closest && target.closest(".vs-dropdown--menu"))
      ) {
        return;
      }
      this.close();
    },
    updateMenuPosition() {
      if (!this.menu || !this.$refs.dropdown) return;
      this.menu.updatePosition(this.$refs.dropdown);
    },
  },
};
</script>
